module.exports = __webpack_public_path__ + "img/94.fcfa37d6.jpg";